export const newRandomHexidecimalKey = () => {
  const hexadecimalDigits = [
    '0', '1', '2', '3', '4', '5', '6', '7',
    '8', '9', 'a', 'b', 'c', 'd', 'e', 'f',
  ];

  return Array.from(Array(32), () => {
    const randomIndex = Math.floor(Math.random() * 16);
    return hexadecimalDigits[randomIndex];
  }).join('');
};
